/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectDailyTaskCommand } from '../../models/delete-project-daily-task-command';
import { DeleteProjectDailyTaskCommandResult } from '../../models/delete-project-daily-task-command-result';

export interface ApiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain$Params {
      body?: DeleteProjectDailyTaskCommand
}

export function apiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectDailyTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectDailyTaskCommandResult>;
    })
  );
}

apiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain.PATH = '/api/ProjectDailyTasks/DeleteProjectDailyTask';
